import { Typography } from "@aircall/tractor";
import styled, { css, TypographyProps } from "@xstyled/styled-components";

import { shouldHighlight } from "./TranscriptionItemUtteranceEntry.utilities";

type StyledEntryProps = TypographyProps & {
  startTime: number;
  currentTime: number;
  active: boolean;
  matched?: boolean;
  isRealTimeTranscription: boolean;
};

const getBgColor = ({
  currentTime,
  startTime,
  active,
  isRealTimeTranscription,
}: StyledEntryProps) => {
  if (
    shouldHighlight(active, startTime, currentTime, isRealTimeTranscription)
  ) {
    return css`
      background-color: graphic-default;
    `;
  }
};

export const Entry = styled(Typography).attrs({ as: "span" })<StyledEntryProps>`
  white-space: pre-wrap;
  ${getBgColor};
  transition: all 0.2s;
`;
